interface HeatMeterProps {
  value: number;
  tag?: string;
}

export default function HeatMeter({ value, tag }: HeatMeterProps) {
  const percent = Math.min(100, Math.round((value / 10000) * 100));
  return (
    <div className="flex items-center gap-2">
      {tag ? (
        <span className="flex h-5 min-w-5 items-center justify-center rounded-md bg-primary-500 px-1.5 font-label text-[11px] leading-none text-white">
          {tag}
        </span>
      ) : null}
      <div className="h-1.5 w-16 overflow-hidden rounded-full bg-background-200">
        <div className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500" style={{ width: `${percent}%` }} />
      </div>
      <span className="font-label text-xs tabular-nums text-foreground-600">{value.toLocaleString()}</span>
    </div>
  );
}